import { useState } from "react";
import { useNavigate } from "react-router-dom";
import OneSNavPanel from "@/components/feature/OneSNavPanel";
import { useDiscussions } from "@/hooks/useDiscussions";
import KpiCards from "./components/KpiCards";
import TasksWidget from "./components/TasksWidget";
import WarehouseAssemblyWidget from "./components/WarehouseAssemblyWidget";
import DeliveriesWidget from "./components/DeliveriesWidget";
import UnpaidWidget from "./components/UnpaidWidget";
import PaymentsWidget from "./components/PaymentsWidget";
import ProcurementRequestsWidget from "./components/ProcurementRequestsWidget";
import ReturnRequestsWidget from "./components/ReturnRequestsWidget";
import UnansweredOffersWidget from "./components/UnansweredOffersWidget";
import ActiveDealsWidget from "./components/ActiveDealsWidget";
import OrdersInProgressWidget from "./components/OrdersInProgressWidget";
import DormantClientsWidget from "./components/DormantClientsWidget";
import AiTipWidget from "./components/AiTipWidget";
import UpsellWidget from "./components/UpsellWidget";
import ManagerKpiWidget from "./components/ManagerKpiWidget";
import CustomerReturnsWidget from "./components/CustomerReturnsWidget";
import DealsKanbanWidget from "./components/DealsKanbanWidget";
import OrdersTab from "./components/OrdersTab";
import TasksTabContent from "./components/TasksTab";
import ClientsTableWidget from "./components/ClientsTableWidget";
import { todayTasks, procurementRequests, returnRequests, customerReturns, communicationGroups } from "@/mocks/managerWorkspace";

export default function ManagerWorkspacePage() {
  const navigate = useNavigate();
  const { toggle: toggleDiscussions } = useDiscussions();
  const [activeTab, setActiveTab] = useState<"dashboard" | "deals" | "orders" | "tasks" | "clients">("dashboard");

  return (
    <div className="h-screen flex flex-col bg-[#FFF9E6] overflow-hidden"
      style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}
    >
      {/* 1C Title Bar */}
      <div className="h-[28px] flex items-center justify-between bg-[#FBED9E] px-3 flex-shrink-0 select-none border-b border-[#D5CA8A]">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1.5">
            <i className="ri-menu-line text-[#666666] text-[13px]"></i>
            <span className="text-[11px] text-[#2D2D2D] font-medium">Методическая база / Управление торговлей, редакция 11 (1С:Предприятие)</span>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-[11px] text-[#666666]">Иванов И.И.</span>
          <div className="w-px h-3 bg-[#D5CA8A]" />
          <i className="ri-settings-3-line text-[#666666] text-[13px] cursor-pointer hover:text-[#2D2D2D]"></i>
          <i className="ri-question-line text-[#666666] text-[13px] cursor-pointer hover:text-[#2D2D2D]"></i>
          <i className="ri-close-line text-[#666666] text-[13px] cursor-pointer hover:text-[#2D2D2D]"></i>
        </div>
      </div>

      {/* 1C Command Bar */}
      <div className="h-[32px] flex items-center gap-1 px-2 bg-[#FFF9E6] border-b border-[#D5CA8A] flex-shrink-0 select-none">
        <div className="flex items-center gap-1">
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
            <i className="ri-file-add-line text-[11px]"></i>
            <span>Создать</span>
          </button>
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
            <i className="ri-file-copy-line text-[11px]"></i>
            <span>Скопировать</span>
          </button>
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
            <i className="ri-delete-bin-line text-[11px]"></i>
            <span>Удалить</span>
          </button>
        </div>
        <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
        <div className="flex items-center gap-1">
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
            <i className="ri-filter-line text-[11px]"></i>
            <span>Фильтры</span>
          </button>
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
            <i className="ri-group-line text-[11px]"></i>
            <span>Группировки</span>
          </button>
        </div>
        <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
        <div className="flex items-center gap-1">
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
            <i className="ri-file-list-3-line text-[11px]"></i>
            <span>Отчёт</span>
          </button>
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
            <i className="ri-printer-line text-[11px]"></i>
            <span>Печать</span>
          </button>
        </div>
        <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
        <div className="flex items-center gap-1 ml-auto">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
          >
            <i className="ri-arrow-left-line text-[11px]"></i>
            <span>Заказы клиентов</span>
          </button>
          <button
            onClick={() => navigate("/operator-workspace")}
            className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
          >
            <i className="ri-user-line text-[10px]"></i>
            <span>Оператор</span>
          </button>
          <button
            onClick={() => navigate("/rop")}
            className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
          >
            <i className="ri-vip-crown-line text-[10px]"></i>
            <span>РОП</span>
          </button>
          <button
            onClick={() => navigate("/client360")}
            className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
          >
            <i className="ri-user-search-line text-[10px]"></i>
            <span>Клиент 360</span>
          </button>
          <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
          <div className="flex items-center gap-1 bg-[#FDF2B5] rounded p-[2px]">
            <span className="px-2 py-[2px] bg-[#E8DB6C] text-[#2D2D2D] rounded text-[11px] font-medium flex items-center gap-1">
              <i className="ri-user-settings-line text-[10px]"></i>
              Рабочее место менеджера
            </span>
          </div>
          <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
          <button
            onClick={toggleDiscussions}
            className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors whitespace-nowrap"
          >
            <i className="ri-chat-3-line text-[11px]"></i>
            <span>Обсуждения</span>
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="h-[32px] flex items-center bg-[#FFF9E6] border-b border-[#D5CA8A] px-1 gap-0 select-none">
        <button className="flex items-center gap-1 px-2 py-1 text-[#666666] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
          <i className="ri-arrow-left-s-line text-[11px]"></i>
        </button>
        <button className="flex items-center gap-1 px-2 py-1 text-[#666666] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
          <i className="ri-arrow-right-s-line text-[11px]"></i>
        </button>
        <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-1 px-3 py-1 text-[11px] rounded-t cursor-pointer transition-colors border border-b-0 bg-[#FFF9E6] text-[#666666] border-[#FFF9E6] hover:bg-[#FDF2B5]"
        >
          <i className="ri-file-list-2-line text-[10px]"></i>
          Заказы клиентов
        </button>
        <button className="flex items-center gap-1 px-3 py-1 text-[11px] rounded-t cursor-pointer transition-colors border border-b-0 bg-white text-[#2D2D2D] border-[#D5CA8A] font-medium">
          <i className="ri-user-settings-line text-[10px]"></i>
          Рабочее место менеджера
          <i className="ri-close-line text-[10px] hover:text-[#666666] ml-1"></i>
        </button>
        <div className="ml-auto flex items-center gap-1 pr-2 text-[10px]">
          <span className="text-[#666666]">Методическая база</span>
          <span className="text-[#666666]">/</span>
          <span className="text-[#666666]">Управление торговлей</span>
          <span className="text-[#666666]">/</span>
          <span className="text-[#2D2D2D] font-medium">Рабочее место менеджера</span>
        </div>
      </div>

      {/* Main area */}
      <div className="flex-1 flex overflow-hidden">
        {/* 1C Navigation Panel */}
        <OneSNavPanel />

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-4">
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <div>
              <h1 className="text-[16px] font-semibold text-[#2D2D2D]">Рабочее место менеджера</h1>
              <p className="text-[11px] text-[#666666]">Главный экран менеджера по продажам</p>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-1.5 bg-[#FDF2B5] rounded-full px-3 py-1.5 border border-[#D5CA8A] cursor-pointer hover:bg-[#FDE68A] transition-colors">
                <i className="ri-star-fill text-[#D97706] text-[14px]"></i>
                <span className="text-[12px] font-semibold text-[#2D2D2D]">Рейтинг</span>
                <span className="text-[12px] font-bold text-[#D97706]">7/15</span>
              </div>
              {communicationGroups.map((group) => (
                <button key={group.key} className="relative flex flex-col items-center gap-0.5 cursor-pointer hover:opacity-80 transition-opacity">
                  <div className="relative">
                    <div className="w-9 h-9 rounded-full bg-[#FEF3C7] border border-[#D5CA8A] flex items-center justify-center">
                      <i className={`${group.icon} text-[16px] text-[#2D2D2D]`}></i>
                    </div>
                    {group.unanswered > 0 && (
                      <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] flex items-center justify-center bg-[#DC2626] text-white text-[9px] font-bold rounded-full px-1">
                        {group.unanswered}
                      </span>
                    )}
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Tab Bar */}
          <div className="flex items-center gap-0 mb-4 border-b border-[#D5CA8A]">
            {([
              { key: "dashboard" as const, label: "Дашборд", icon: "ri-dashboard-line" },
              { key: "deals" as const, label: "Сделки", icon: "ri-shake-hands-line" },
              { key: "orders" as const, label: "Заказы", icon: "ri-file-list-2-line" },
              { key: "tasks" as const, label: "Задачи", icon: "ri-task-line" },
              { key: "clients" as const, label: "Клиенты", icon: "ri-group-line" },
            ]).map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`flex items-center gap-1.5 px-4 py-2 text-[11px] font-medium cursor-pointer transition-colors border-b-2 -mb-[1px] whitespace-nowrap ${
                  activeTab === tab.key
                    ? "text-[#2D2D2D] border-[#D97706] bg-white rounded-t"
                    : "text-[#666666] border-transparent hover:text-[#2D2D2D] hover:bg-[#FDF2B5]/50 rounded-t"
                }`}
              >
                <i className={`${tab.icon} text-[12px]`}></i>
                {tab.label}
              </button>
            ))}
          </div>

          {/* Dashboard Content */}
          {activeTab === "dashboard" && (
            <>
          {/* Row 1: KPI Cards */}
          <div className="grid grid-cols-1 gap-4 mb-4">
            <KpiCards />
          </div>

          {/* Row 2: Задачи на сегодня + Активные сделки + КП без ответа */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
            <div className="min-h-[280px]">
              <TasksWidget />
            </div>
            <div className="min-h-[280px]">
              <ActiveDealsWidget />
            </div>
            <div className="min-h-[280px]">
              <UnansweredOffersWidget />
            </div>
          </div>

          {/* Row 3: Заказы в работе + Сборка на складе + Доставки сегодня */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
            <div className="min-h-[280px]">
              <OrdersInProgressWidget />
            </div>
            <div className="min-h-[280px]">
              <WarehouseAssemblyWidget />
            </div>
            <div className="min-h-[280px]">
              <DeliveriesWidget />
            </div>
          </div>

          {/* Row 3.5: Клиенты с долгом + Последние оплаты + Запрос в отдел закупок */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
            <div className="min-h-[280px]">
              <UnpaidWidget />
            </div>
            <div className="min-h-[280px]">
              <PaymentsWidget />
            </div>
            <div className="min-h-[280px]">
              <ProcurementRequestsWidget />
            </div>
          </div>

          {/* Row 4: Заявки на возврат + Возвраты от покупателей + (пусто) */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
            <div className="min-h-[280px]">
              <ReturnRequestsWidget />
            </div>
            <div className="min-h-[280px]">
              <CustomerReturnsWidget />
            </div>
          </div>

          {/* Divider */}
          <div className="mb-4 pt-2 border-t-2 border-[#D5CA8A]/40">
            <p className="text-[11px] font-semibold text-[#666666] mb-3">Дополнительные разделы</p>
          </div>

          {/* Row 5: AI-подсказка + Давно не покупали + Допродажи */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
            <div className="min-h-[160px]">
              <AiTipWidget />
            </div>
            <div className="min-h-[160px]">
              <DormantClientsWidget />
            </div>
            <div className="min-h-[160px]">
              <UpsellWidget />
            </div>
          </div>

          {/* Row 8: Manager KPI Dashboard */}
          <div className="mb-4">
            <ManagerKpiWidget />
          </div>

          {/* Bottom status bar */}
          <div className="h-[24px] flex items-center px-2 bg-[#FBED9E] border border-[#D5CA8A] text-[10px] text-[#666666] select-none rounded">
            <span>Последнее обновление: 24.06.2026 | Задач: {todayTasks} | Сделок: 18 | КП без ответа: 4 | Долгов: 9 | Сборка: 4 | Доставок: 4 | Запросов в закупку: {procurementRequests.length} | Заявок на возврат: {returnRequests.length} | Возвратов: {customerReturns.length}</span>
            <span className="ml-auto">1С:Предприятие 8.3.25.1448</span>
          </div>
            </>
          )}

          {/* Deals Tab */}
          {activeTab === "deals" && (
            <div className="flex-1 flex flex-col">
              <DealsKanbanWidget />
            </div>
          )}

          {/* Orders Tab */}
          {activeTab === "orders" && (
            <div className="flex-1 flex flex-col">
              <OrdersTab />
            </div>
          )}

          {/* Tasks Tab */}
          {activeTab === "tasks" && (
            <div className="flex-1 flex flex-col">
              <TasksTabContent />
            </div>
          )}

          {/* Clients Tab */}
          {activeTab === "clients" && (
            <div className="flex-1 flex flex-col">
              <ClientsTableWidget />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}